import React from "react";
import TrackHome from "./TrackHome";
import Row from "react-bootstrap/Row";
import HomeHeader from "./HomeHeader";
import { useSettings } from "~/Context/SettingsContext";

const TrackHomeList = (props) => {
  const { settings, toggleLayout, toggleJukebox, toggleJukeboxAutoPlay } = useSettings();
  return (
    <React.Fragment>
      <HomeHeader
        settings={settings}
        toggleLayout={toggleLayout}
        toggleJukebox={toggleJukebox}
        toggleJukeboxAutoPlay={toggleJukeboxAutoPlay}
        checkRecent={props.checkRecent}
        date={props.date}
        daysAgo={props.daysAgo}
      />
      <Row>
        <TrackHome {...props} />
        {/* {!props.loading && props.todaysTracks && props.todaysTracks.length === 0 && (
          <div>No tracks were posted today.</div>
        )} */}
      </Row>
    </React.Fragment>
  );
};

TrackHomeList.propTypes = {};

export default TrackHomeList;
